module.exports = __webpack_public_path__ + "static/media/blog-administracion-sistemas-programacion-500.8d338870.jpg";